export default "__VITE_ASSET__Dq_V82$I__"